import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import Hero from 'common/Hero'
import HeroTitle from 'common/Hero/title'

import PageContent from 'common/PageContent'
import Section from 'common/Section'
import SectionTitle from 'common/Section/title'
import PositionsTable from 'views/common/PositionsTable'

import { setTitle } from 'reducers/global'
import { capitalizeFirstLetter } from 'services/string'

class LocationDetailPage extends React.Component {
  constructor (props) {
    super(props)
    const name = props.match.params.locationId

    props.dispatch(setTitle(capitalizeFirstLetter(name)))
  }

  render () {
    const name = this.props.match.params.locationId

    return (
      <div>
        <Hero background={this.props.background}>
          <HeroTitle className='ttc'>
            {name}
          </HeroTitle>
        </Hero>
        <PageContent>
          <Section>
            <SectionTitle>Current Openings</SectionTitle>
            <PositionsTable hideLocation location={name} />
          </Section>
        </PageContent>
      </div>
    )
  }
}

export default connect()(withRouter(LocationDetailPage))
